import Icon, { type IconName } from "@repo/ui/components/ui/icon/icon";
import { forwardRef } from "react";
import { cva, VariantProps } from "class-variance-authority";
import { cn } from "@repo/ui/lib/utils";

const buttonVariants = cva(
  "inline-flex justify-start items-center whitespace-nowrap font-normal text-base gap-[16px] px-[20px] h-10 w-min transition-colors disabled:pointer-events-none disabled:opacity-50 hover:opacity-70",
  {
    variants: {
      variant: {
        default:
          "rounded-3xl text-secondary-black bg-primary-white stroke-primary-magenta",
        ghost:
          "px-0 bg-transparent fill-primary-black dark:fill-primary-white stroke-primary-black dark:stroke-primary-white justify-between",
        underline:
          "border-b-2 border-primary-black dark:border-primary-white px-0 bg-transparent justify-between",
        underlineReverse:
          "flex-row-reverse border-b-2 border-primary-black dark:border-primary-white px-0 bg-transparent justify-between *:rotate-180",
        error:
          "rounded-3xl stroke-primary-white bg-secondary-red text-primary-white dark:bg-secondary-red dark:text-primary-white dark:stroke-primary-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  icon: IconName;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, children, variant, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        {...props}
        className={cn(buttonVariants({ variant, className }))}
      >
        {children}
        <Icon icon={icon} className="h-[17px] w-[17px]" />
      </button>
    );
  },
);
